var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIgnore = function SvgIgnore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m17.738 12.537-2.414-1.912c0-.054.027-.082.027-.136a.84.84 0 0 0-.241-.574c-.51-.574-1.502-1.42-1.502-4.234 0-2.103-1.448-3.796-3.432-4.233V.874c0-.464-.375-.874-.83-.874-.484 0-.859.41-.859.874v.574c-1.1.245-2.011.846-2.628 1.72L1.971.11a.397.397 0 0 0-.59.082L.846.874a.413.413 0 0 0 .08.601l15.767 12.428c.188.164.456.11.59-.082l.536-.683a.414.414 0 0 0-.08-.6M4.975 6.883c-.242 1.858-.993 2.54-1.422 3.032-.16.164-.24.383-.214.574 0 .464.322.874.858.874h6.489zm4.37 7.102c.938 0 1.69-.765 1.69-1.748H7.628c0 .983.75 1.748 1.716 1.748"
  })));
};
export default SvgIgnore;